import { Schedule } from '@mui/icons-material';
import { type ProfileEditType } from '@on3/api';
import { Popover } from '@on3/ui-lib/components/Popover';
import { useRef } from 'react';

import styles from './PendingTile.module.scss';

type PendingEditChange = {
  current: string;
  change: string;
};

type PendingEdit = {
  $type: ProfileEditType;
  key: number;
  message: string;
  changes?: PendingEditChange[]; // TODO: implement changes
};

interface PendingTileProps {
  edits: PendingEdit[];
}

export const PendingTile = ({ edits = [] }: PendingTileProps) => {
  const ref = useRef<HTMLButtonElement>(null);

  return (
    <Popover className={styles.block}>
      {({ isOpen, setIsOpen, Wrapper }) => (
        <>
          <button
            className={styles.button}
            onBlur={() => setIsOpen(false)}
            onClick={() => setIsOpen(!isOpen)}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
            ref={ref}
            type="button"
          >
            <Schedule />
            <span>{edits.length}</span>
            <span>{edits.length > 1 ? 'Pending Edits' : 'Pending Edit'}</span>
          </button>
          {isOpen && (
            <Wrapper className={styles.pendingEditsWrapper} controlRef={ref}>
              <div className={styles.pendingEdits}>
                {edits.map((edit) => (
                  <div className={styles.edit} key={edit.key}>
                    <p>{edit.message}</p>
                  </div>
                ))}
              </div>
            </Wrapper>
          )}
        </>
      )}
    </Popover>
  );
};
